import React, { useEffect } from 'react';
import { View, Text, useWindowDimensions } from 'react-native';
import { Image } from 'expo-image';
import * as SplashScreen from 'expo-splash-screen';
import SolidButton from './SolidButton';
import usePlatform from '../../utils/hooks/usePlatform';
import { reloadAppAsync } from 'expo';
import { reloadAsync } from 'expo-updates';
import { StyleSheet, useUnistyles } from 'react-native-unistyles';

const MaintenanceScreen = ({ message, scheme: propScheme }) => {
    useEffect(() => {
        SplashScreen.hide();
    }, []);

    const { isWeb, isNative, isLandscape } = usePlatform();
    const { rt: { themeName } } = useUnistyles();
    const { width } = useWindowDimensions();

    const scheme = propScheme || themeName;
    const imgWidth = width * (isLandscape ? 0.5 : 1.4);
    const source = scheme === 'light' ? require('@/assets/bear/maintenance_light.png') : require('@/assets/bear/maintenance_dark.png');
    const bgColor = scheme === 'light' ? '#FEFEFE' : '#000611';

    const handleReload = async () => {
        if (isNative && __DEV__) {
            reloadAppAsync();
        } else if (isNative && !__DEV__) {
            reloadAsync();
        } else if (isWeb) {
            window.location.reload();
        }
    };

    return (
        <View style={[styles.container(isWeb), { backgroundColor: bgColor }]}>
            <Image
                source={source}
                style={{ width: imgWidth, aspectRatio: 1536 / 1024 }}
                contentFit="contain"
            />
            <SolidButton text="Retry" width={200} onPress={handleReload} variant='muted' type="primary" />
        </View>
    );
};

const styles = StyleSheet.create(({ colors, fonts }) => ({
    container: (isWeb) => ({
        flex: 1,
        minHeight: isWeb ? '100vh' : undefined,
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: isWeb ? 32 : 0,
        gap: 16,
    }),
    title: {
        color: colors.text,
        fontSize: 32,
        fontFamily: fonts.heading,
        marginBottom: 4,
    },
    message: {
        marginBottom: 16,
        color: colors.textSecondary,
        fontSize: 16,
        fontFamily: fonts.body,
    },
}));

export default MaintenanceScreen;
